import { PublicVaultsRequestArgs } from "@decibeltrade/sdk";
import { FetchQueryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { readDexSdk } from "@/contexts/dex-sdk";

import { addSubaccountAddressToVault } from "./utils";

const VAULT_QUERY_KEY = "vaults";

export function vaultQueryKey(args?: PublicVaultsRequestArgs) {
  return [
    VAULT_QUERY_KEY,
    args?.vaultType,
    args?.offset,
    args?.limit,
    args?.address,
    args?.search,
    args?.sortKey,
    args?.sortDir,
  ] as const;
}

export function vaultQuery(args?: PublicVaultsRequestArgs) {
  return {
    queryKey: vaultQueryKey(args),
    queryFn: () =>
      readDexSdk.vaults.getVaults(args).then((vaults) =>
        // @Todo: Maybe we can do this on the server side instead of the client side
        ({
          ...vaults,
          items: vaults.items.map(addSubaccountAddressToVault),
        }),
      ),
  } satisfies FetchQueryOptions;
}

export function useVaults(args?: PublicVaultsRequestArgs) {
  return useSuspenseQuery({
    ...vaultQuery(args),
    refetchInterval: 30_000,
    staleTime: 30_000, // Prevent suspending on refetch by keeping data fresh
  });
}
